import { readEntity } from 'reactifi';

export function loadLanguages() {
  return readEntity('languages');
}
